import type { AssetTreeNode } from './types';

/**
 * 트리의 모든 체크 가능한 키를 재귀적으로 수집합니다.
 * 체크 가능한 노드는 리프 노드(스키마)입니다.
 */
export const getAllCheckableKeys = (nodes: AssetTreeNode[]): React.Key[] => {
  const keys: React.Key[] = [];

  const traverse = (node: AssetTreeNode) => {
    if (node.isLeaf) {
      keys.push(node.key);
    }

    if (node.children && node.children.length > 0) {
      node.children.forEach(traverse);
    }
  };

  nodes.forEach(traverse);
  return keys;
};
